import React, {useState} from 'react';
import {Checkbox} from "primereact/checkbox";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import {addToDate} from "utils/time-utils";
import {Button} from "primereact/button";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {useClearDatasetData} from "../../../../../api/api-hooks/datasets-hooks";
import {easasAlert} from "../../../../fragments/easas-global-fragment/EasasGlobalAlerts";

const ClearDatasetDialog = ({setClearDataDialogVisibility, selectedDatasetID}) => {
    const [clearAllCheck, setClearAllCheck] = useState(false)
    const [dateFrom, setDateFrom] = useState<Date>(addToDate(new Date(), -1, 'HOURS'));
    const [dateTo, setDateTo] = useState<Date>(new Date());

    const clearDataClickHandler = (e) => {
        e.preventDefault();
        confirmDialog({
            message: `Do you want to clear dataset data?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => clearData(),
        });
    }

    const { mutate } = useClearDatasetData();

    const clearData = () => {
        const timeStart = dateFrom.toISOString();
        const timeEnd = dateTo.toISOString();
        const clearAll = clearAllCheck;
        const query = {timeStart, timeEnd, clearAll, identifiers: [selectedDatasetID[0].identifier]}

        mutate(query, {
            onSuccess: () => {
                easasAlert('DATASET CLEARED', 'Data has been cleared', 'success')
            },
            onError: (error) => {
                easasAlert('CLEARING FAILED', `${error}`, 'error')
            }
        })
        setClearDataDialogVisibility(false)
    }

    return (
        <div className='flex flex-column gap-5'>
            <div className='flex justify-content-between align-items-center'>
                <label htmlFor='clear-all'> Clear all data:</label>
                <Checkbox id='clear-all'
                          className='mr-5'
                          checked={clearAllCheck}
                          onChange={() => setClearAllCheck(prevState => !prevState)}
                />
            </div>
            {!clearAllCheck && <>
                <div className='flex justify-content-between align-items-center'>
                    <label htmlFor='date-from'> Clear data from:</label>
                    <CalendarWrapper id='date-from' value={dateFrom} onChange={setDateFrom}/>
                </div>
                <div className='flex justify-content-between align-items-center'>
                    <label htmlFor='date-to'> Clear data to:</label>
                    <CalendarWrapper id='date-to' className='mr-0' value={dateTo} onChange={setDateTo}/>
                </div>
            </>
            }
            <div className='flex justify-content-between align-items-center'>
                <Button label='Cancel' onClick={() => setClearDataDialogVisibility(false)}/>
                <ConfirmDialog />
                <Button label='Clear data' className='mr-5 p-button-danger' onClick={(e) => clearDataClickHandler(e)}/>
            </div>
        </div>
    )
}

export default ClearDatasetDialog;